"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.Background = styled_components_1.default.div `
  position: relative;
  opacity: ${({ disabled }) => (disabled ? "0.4" : "1")};
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
  background-color: ${({ isEnabled, activeColor, inactiveColor }) => isEnabled ? activeColor : inactiveColor};
  width: 2.5em;
  height: 1.3em;
  border-radius: 0.65em;
  cursor: pointer;
  transition: all 0.25s ease;
`;
exports.Handle = styled_components_1.default.div `
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(
    ${({ isEnabled }) => isEnabled ? "calc(2.5em - 100% - 0.065em)" : "0.065em"},
    -50%
  );
  width: 1.15em;
  height: 1.15em;
  border-radius: 50%;
  opacity: ${({ disabled }) => (disabled ? "0.4" : "1")};
  pointer-events: none;
  background-color: ${({ isEnabled, activeColor, inactiveColor }) => isEnabled ? activeColor : inactiveColor};
  transition: all 0.25s ease;
`;
//# sourceMappingURL=styledEntities.js.map